// Helpers to get modified data from redux store
import { createSelector } from '@reduxjs/toolkit';

export const isAdminSelector = createSelector(state => state.auth.user, user => {
    const {email} = user;
    // removed ptop.co.il
    return email && (email.includes('bllink.co'));
});

export const isGuestSelector = createSelector(state => state.auth.user, user => {
    const {email} = user;
    return !email
});


export const isDevSelector = createSelector(state => state.auth.user, user => {
    const { email } = user;
    const devs = [
        'ohad@bllink.co',
        'dmitry@bllink.co',
        'ariel@bllink.co',
        'dmytro@bllink.co',
        'rayee@bllink.co',
        // 'mor@bllink.co'
    ];
    return email && devs.includes(email);
});


export const isPartnerAllowedSeeChequeScanner = createSelector(state => state.auth.userProfile, userProfile => {
    const {partnerID} = userProfile;
    let allowedPartners = [

    ];
    return partnerID && allowedPartners.includes(partnerID);
});

export const shouldHideRewardsSelector = createSelector(state => state.auth.userProfile, userProfile => {
    const {partnerID} = userProfile;
    let hideFromPartners = [
        'Adems', 'US Demo', 'Chung', 'ZoharHoldongs'
    ];
    return partnerID && hideFromPartners.includes(partnerID);
});


export const isPartnerAllowedSeeNewFeature = createSelector(state => state.auth.userProfile, userProfile => {
    /*
        generic function to gradually rollout new features
        for partners
     */
    const {partnerID} = userProfile;
    let allowedPartners = [
        'agas',
        'bllink',
        'alon',
        'clinton'
    ];
    return partnerID && allowedPartners.includes(partnerID);
});
